import { render, staticRenderFns } from "./OrderArchive.vue?vue&type=template&id=29327697"
import script from "./OrderArchive.vue?vue&type=script&lang=js"
export * from "./OrderArchive.vue?vue&type=script&lang=js"
import style0 from "./OrderArchive.vue?vue&type=style&index=0&id=29327697&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports